(function () {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = Number(number);
    if (!Number.isFinite(value)) return '0';
    var parts = (value / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, moneyFormat, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    var format = String(moneyFormat || '').replace(/<[^>]*>/g, '');
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (match) {
      var formatted;
      switch (match[1]) {
        case 'amount':
          formatted = formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_with_comma_separator':
          formatted = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          formatted = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals':
        default:
          formatted = formatWithDelimiters(cents, 0, ',', '.');
          break;
      }
      return format.replace(match[0], formatted);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'ja', {
        style: 'currency',
        currency: currency || 'JPY',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0
      }).format(Math.round(cents / 100));
    } catch (error) {
      return String(Math.round(cents / 100));
    }
  }

  function replaceToken(template, token, value) {
    return String(template || '').replace(new RegExp(token, 'g'), String(value));
  }

  function getCartController() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionIds(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
    return cart.getSectionsToRender().map(function (section) { return section.id; });
  }

  function renderCartContents(cart, response) {
    if (!cart || typeof cart.renderContents !== 'function') {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    if (cart.tagName.toLowerCase() === 'cart-notification' && response.items && response.items.length) {
      cart.cartItemKey = response.items[response.items.length - 1].key;
    }

    try {
      cart.renderContents(response);
    } catch (error) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  function makeMountGroup() {
    var randomPart = Math.random().toString(36).slice(2, 9);
    return 'ag-mount-' + Date.now().toString(36) + '-' + randomPart;
  }

  function formToItem(form, mountGroup) {
    var formData = new FormData(form);
    var properties = {};
    var propertyPattern = /^properties\[(.*)\]$/;

    formData.forEach(function (value, key) {
      var match = key.match(propertyPattern);
      if (match && value !== '') properties[match[1]] = String(value);
    });

    if (mountGroup) properties._ag_mount_group = mountGroup;

    return {
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity')),
      properties: properties
    };
  }

  function initPurchase(root) {
    var purchase = root.querySelector('[data-ag-cf-purchase]');
    if (!purchase || purchase.dataset.agCfPurchaseBound === 'true') return;
    purchase.dataset.agCfPurchaseBound = 'true';

    var seriesInput = purchase.querySelector('[data-cf-quantity-input]');
    var quantitySelect = purchase.querySelector('[data-cf-quantity-select]');
    var quantityContinue = purchase.querySelector('[data-cf-quantity-continue]');
    var currentOfferPlan = purchase.querySelector('[data-cf-current-offer-plan]');
    var currentOfferQuantity = purchase.querySelector('[data-cf-current-offer-quantity]');
    var currentOfferOriginal = purchase.querySelector('[data-cf-current-offer-original]');
    var currentOfferOriginalValue = purchase.querySelector('[data-cf-current-offer-original-value]');
    var currentOfferPrice = purchase.querySelector('[data-cf-current-offer-price]');
    var currentOfferPer = purchase.querySelector('[data-cf-current-offer-per]');
    var currentOfferBenefit = purchase.querySelector('[data-cf-current-offer-benefit]');
    var currentOfferShipping = purchase.querySelector('[data-cf-current-offer-shipping]');
    var finalForm = purchase.querySelector('[data-cf-final-form]');
    var finalCta = purchase.querySelector('[data-cf-final-cta]');
    var finalQuantityInput = finalForm && finalForm.querySelector('[data-cf-final-quantity]');
    var mountRow = purchase.querySelector('[data-cf-mount-row]');
    var mountDialog = purchase.querySelector('[data-cf-mount-dialog]');
    var mountOpen = purchase.querySelector('[data-cf-mount-open]');
    var mountClose = purchase.querySelector('[data-cf-mount-close]');
    var mountDone = purchase.querySelector('[data-cf-mount-done]');
    var mountMinus = purchase.querySelector('[data-cf-mount-minus]');
    var mountPlus = purchase.querySelector('[data-cf-mount-plus]');
    var mountQuantityOutput = purchase.querySelector('[data-cf-mount-quantity-output]');
    var mountRange = purchase.querySelector('[data-cf-mount-range]');
    var mountRangeCompact = purchase.querySelector('[data-cf-mount-range-compact]');
    var mountQuick = purchase.querySelector('[data-cf-mount-quick]');
    var mountQuickLabel = purchase.querySelector('[data-cf-mount-quick-label]');
    var mountQuickMeta = purchase.querySelector('[data-cf-mount-quick-meta]');
    var mountDialogTotal = purchase.querySelector('[data-cf-mount-dialog-total]');
    var mountState = purchase.querySelector('[data-cf-mount-state]');
    var mountRowTotal = purchase.querySelector('[data-cf-mount-row-total]');
    var mountAlign = purchase.querySelector('[data-cf-mount-align]');
    var mountTriggerLabel = purchase.querySelector('[data-cf-mount-trigger-label]');
    var summaryArtworkQuantity = purchase.querySelector('[data-cf-summary-artwork-quantity]');
    var summaryArtwork = purchase.querySelector('[data-cf-summary-artwork]');
    var summaryMountQuantity = purchase.querySelector('[data-cf-summary-mount-quantity]');
    var summaryMountPrice = purchase.querySelector('[data-cf-summary-mount-price]');
    var summaryShipping = purchase.querySelector('[data-cf-summary-shipping]');
    var summaryArtworkEdit = purchase.querySelector('[data-cf-summary-artwork-edit]');
    var summaryMountEdit = purchase.querySelector('[data-cf-summary-mount-edit]');
    var summaryTotal = purchase.querySelector('[data-cf-summary-total]');
    var artworkOptions = purchase.querySelector('[data-cf-artwork-options]');
    var artworkOptionsTitle = purchase.querySelector('[data-cf-artwork-options-title]');
    var artworkQuantityAnchor = purchase.querySelector('[data-ag-scroll-anchor="artwork-quantity"]');
    var artworkOptionsAnchor = purchase.querySelector('[data-ag-scroll-anchor="artwork-options"]');
    var orderFlowAnchor = document.querySelector('[data-ag-scroll-anchor="order-flow"]');
    var detailBridge = purchase.querySelector('[data-cf-detail-bridge]');
    var currency = root.dataset.currency || 'JPY';
    var basePrice = Number(root.dataset.basePrice || 0);
    var moneyFormat = purchase.dataset.cfMoneyFormat || '';
    var pairQuantity = Number(purchase.dataset.cfPairQuantity || 2);
    var pairDiscount = Number(purchase.dataset.cfPairDiscount || 5);
    var seriesMinimum = Number(purchase.dataset.cfSeriesMin || 3);
    var seriesDiscount = Number(purchase.dataset.cfSeriesDiscount || 10);
    var artworkMaxQuantity = Math.max(seriesMinimum, Math.min(10, Number(purchase.dataset.cfQuantityMax || 10)));
    var displayShippingFee = Number(purchase.dataset.cfDisplayShippingFee || 0);
    var shippingThreshold = Number(purchase.dataset.cfShippingThreshold || 0);
    var shippingFee = Number(purchase.dataset.cfShippingFee || 0);
    var shippingFreeValue = purchase.dataset.cfShippingFreeValue || '';
    var shippingCheckoutLabel = purchase.dataset.cfShippingCheckoutLabel || '';
    var isInternational = purchase.dataset.cfIsInternational === 'true';
    var artworkQuantityUnit = purchase.dataset.cfArtworkQuantityUnit || ' artworks';
    var summaryEditLabel = purchase.dataset.cfSummaryEditLabel || 'Edit ›';
    var summaryAddLabel = purchase.dataset.cfSummaryAddLabel || 'Add ›';
    var mountVariantId = Number(purchase.dataset.cfMountVariantId || 0);
    var mountUnitPrice = Number(purchase.dataset.cfMountPrice || 0);
    var mountQuantityUnit = purchase.dataset.cfMountQuantityUnit || 'artwork';
    var mountQuantity = 0;
    var activePlan = 'series';
    var lockedScrollY = 0;
    var savedBodyStyles = null;
    var savedHtmlStyles = null;
    var closeTimer = null;
    var dialogReturnFocus = mountOpen;
    var decisionClosePending = false;

    function getArtworkQuantity(plan) {
      if (plan === 'pair') return pairQuantity;
      if (plan === 'single') return 1;
      return Math.max(seriesMinimum, Math.min(artworkMaxQuantity, Number(seriesInput && seriesInput.value) || seriesMinimum));
    }

    function getArtworkTotal(plan) {
      var quantity = getArtworkQuantity(plan);
      if (plan === 'pair') return Math.round(basePrice * quantity * (100 - pairDiscount) / 100);
      if (plan === 'single') return basePrice;
      return Math.round(basePrice * quantity * (100 - seriesDiscount) / 100);
    }

    function getShippingTotal(subtotal) {
      if (isInternational || shippingThreshold <= 0) return 0;
      return subtotal >= shippingThreshold ? 0 : shippingFee;
    }

    function getShippingValue(subtotal) {
      if (isInternational) return shippingCheckoutLabel;
      return getShippingTotal(subtotal) > 0 ? formatMoney(shippingFee, moneyFormat, currency) : shippingFreeValue;
    }

    function getPlanLabel(plan, quantity) {
      if (plan === 'single') return purchase.dataset.cfSingleTitle || 'SINGLE';
      if (plan === 'pair') return purchase.dataset.cfPairTitle || 'PAIR';
      if (quantity >= seriesMinimum + 1) return purchase.dataset.cfSeriesTitleQty4 || 'SERIES';
      return purchase.dataset.cfSeriesTitle || 'SIGNATURE SERIES';
    }

    function getPlanForQuantity(quantity) {
      if (quantity === 1) return 'single';
      if (quantity === pairQuantity) return 'pair';
      return 'series';
    }

    function setArtworkQuantity(quantity) {
      var nextQuantity = Math.max(1, Math.min(artworkMaxQuantity, Number(quantity) || 1));
      activePlan = getPlanForQuantity(nextQuantity);
      if (seriesInput) seriesInput.value = nextQuantity;
      if (quantitySelect) quantitySelect.value = String(nextQuantity);
      updatePurchaseState();
    }

    function updatePurchaseState() {
      var artworkQuantity = getArtworkQuantity(activePlan);
      var rangeTemplate = purchase.dataset.cfMountRangeTemplate || '';
      var compactRangeTemplate = purchase.dataset.cfMountRangeCompactTemplate || rangeTemplate;
      var quickTemplate = purchase.dataset.cfMountQuickSeriesTemplate || '';

      mountQuantity = Math.max(0, Math.min(mountQuantity, artworkQuantity));
      var mountTotal = mountQuantity * mountUnitPrice;
      var artworkTotal = getArtworkTotal(activePlan);
      var shippingTotal = getShippingTotal(artworkTotal + mountTotal);
      if (mountQuantityOutput) mountQuantityOutput.textContent = mountQuantity;
      if (mountRow) mountRow.dataset.cfMountQuantity = mountQuantity;
      if (mountState) mountState.textContent = mountQuantity > 0
        ? replaceToken(purchase.dataset.cfMountSelectedTemplate, '__QUANTITY__', mountQuantity)
        : purchase.dataset.cfMountUnselected;
      if (mountRowTotal) {
        mountRowTotal.hidden = mountQuantity === 0;
        mountRowTotal.textContent = mountQuantity > 0 ? formatMoney(mountTotal, moneyFormat, currency) : '';
      }
      if (mountTriggerLabel) mountTriggerLabel.textContent = mountQuantity > 0
        ? purchase.dataset.cfMountChange
        : purchase.dataset.cfMountAdd;
      if (mountAlign) {
        mountAlign.hidden = mountQuantity === 0 || mountQuantity >= artworkQuantity;
        mountAlign.textContent = replaceToken(purchase.dataset.cfMountAlignTemplate, '__QUANTITY__', artworkQuantity);
      }
      if (mountRange) mountRange.textContent = replaceToken(rangeTemplate, '__MAX__', artworkQuantity);
      if (mountRangeCompact) mountRangeCompact.textContent = replaceToken(compactRangeTemplate, '__MAX__', artworkQuantity);
      if (mountMinus) {
        mountMinus.disabled = mountQuantity <= 0;
        mountMinus.setAttribute('aria-disabled', mountQuantity <= 0 ? 'true' : 'false');
      }
      if (mountPlus) {
        mountPlus.disabled = mountQuantity >= artworkQuantity;
        mountPlus.setAttribute('aria-disabled', mountQuantity >= artworkQuantity ? 'true' : 'false');
      }
      if (mountQuick) {
        mountQuick.hidden = mountQuantity >= artworkQuantity;
        if (activePlan === 'single') {
          quickTemplate = purchase.dataset.cfMountQuickSingle || '';
        } else if (activePlan === 'pair') {
          quickTemplate = purchase.dataset.cfMountQuickPairTemplate || '';
        }
        if (mountQuickLabel) mountQuickLabel.textContent = replaceToken(quickTemplate, '__QUANTITY__', artworkQuantity);
        if (mountQuickMeta) mountQuickMeta.textContent = artworkQuantity > 0
          ? artworkQuantity + mountQuantityUnit + ' / ' + formatMoney(artworkQuantity * mountUnitPrice, moneyFormat, currency)
          : '';
      }
      if (mountDialogTotal) {
        mountDialogTotal.textContent = mountQuantity + mountQuantityUnit + ' / ' + formatMoney(mountTotal, moneyFormat, currency);
      }
      if (quantitySelect) quantitySelect.value = String(artworkQuantity);
      if (currentOfferPlan) currentOfferPlan.textContent = getPlanLabel(activePlan, artworkQuantity);
      if (currentOfferQuantity) currentOfferQuantity.textContent = artworkQuantity + artworkQuantityUnit;
      if (currentOfferOriginal) currentOfferOriginal.hidden = activePlan === 'single';
      if (currentOfferOriginalValue) currentOfferOriginalValue.textContent = formatMoney(basePrice * artworkQuantity + displayShippingFee, moneyFormat, currency);
      if (currentOfferPrice) currentOfferPrice.textContent = formatMoney(artworkTotal, moneyFormat, currency);
      if (currentOfferPer) {
        currentOfferPer.hidden = activePlan === 'single';
        currentOfferPer.textContent = formatMoney(Math.round(artworkTotal / artworkQuantity), moneyFormat, currency) + (purchase.dataset.cfPerArtwork || ' / artwork');
      }
      if (currentOfferBenefit) {
        currentOfferBenefit.hidden = activePlan === 'single';
        if (activePlan === 'pair') currentOfferBenefit.textContent = purchase.dataset.cfPairBenefit || '';
        else if (artworkQuantity >= seriesMinimum + 1) currentOfferBenefit.textContent = purchase.dataset.cfSeriesBenefitQty4 || '';
        else currentOfferBenefit.textContent = purchase.dataset.cfSeriesBenefit || '';
      }
      if (currentOfferShipping) {
        currentOfferShipping.hidden = isInternational;
        if (activePlan === 'single') currentOfferShipping.textContent = purchase.dataset.cfSingleShipping || '';
        else if (activePlan === 'pair') currentOfferShipping.textContent = purchase.dataset.cfPairShipping || '';
        else currentOfferShipping.textContent = purchase.dataset.cfSeriesShipping || '';
      }
      if (summaryArtworkQuantity) summaryArtworkQuantity.textContent = artworkQuantity + artworkQuantityUnit;
      if (summaryArtwork) summaryArtwork.textContent = formatMoney(artworkTotal, moneyFormat, currency);
      if (summaryMountQuantity) summaryMountQuantity.textContent = mountQuantity > 0
        ? mountQuantity + mountQuantityUnit
        : purchase.dataset.cfMountNone;
      if (summaryMountPrice) {
        summaryMountPrice.hidden = mountQuantity === 0;
        summaryMountPrice.textContent = mountQuantity > 0 ? formatMoney(mountTotal, moneyFormat, currency) : '';
      }
      if (summaryShipping) summaryShipping.textContent = getShippingValue(artworkTotal + mountTotal);
      if (summaryTotal) summaryTotal.textContent = formatMoney(artworkTotal + mountTotal + shippingTotal, moneyFormat, currency);
      if (summaryArtworkEdit) summaryArtworkEdit.textContent = summaryEditLabel;
      if (summaryMountEdit) summaryMountEdit.textContent = mountQuantity > 0 ? summaryEditLabel : summaryAddLabel;
      if (finalQuantityInput) finalQuantityInput.value = artworkQuantity;
      if (finalCta) {
        var finalTemplate = finalCta.dataset.cfFinalCtaTemplateSeries || '';
        if (activePlan === 'pair') finalTemplate = finalCta.dataset.cfFinalCtaPair || '';
        if (activePlan === 'single') finalTemplate = finalCta.dataset.cfFinalCtaSingle || '';
        finalCta.textContent = replaceToken(finalTemplate, '__QUANTITY__', artworkQuantity);
      }
    }

    function shouldReduceMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollToTarget(target, focusTarget) {
      if (!target) return;
      target.scrollIntoView({ behavior: shouldReduceMotion() ? 'auto' : 'smooth', block: 'start' });
      var nextFocusTarget = focusTarget && typeof focusTarget.focus === 'function' ? focusTarget : null;
      if (nextFocusTarget) {
        window.setTimeout(function () { nextFocusTarget.focus({ preventScroll: true }); }, shouldReduceMotion() ? 0 : 260);
      }
    }

    function scrollToArtworkOptions(focusTarget) {
      var target = artworkOptionsAnchor || artworkOptions;
      var nextFocusTarget = focusTarget && typeof focusTarget.focus === 'function' ? focusTarget : artworkOptionsTitle || artworkOptions;
      scrollToTarget(target, nextFocusTarget);
    }

    function scrollToArtworkQuantity(focusTarget) {
      var target = artworkQuantityAnchor || quantitySelect;
      var nextFocusTarget = focusTarget && typeof focusTarget.focus === 'function' ? focusTarget : quantitySelect;
      scrollToTarget(target, nextFocusTarget);
    }

    function scrollToDetailBridgeTarget() {
      var howSection = document.querySelector('#ag-cf-v3-how');
      var howHeading = howSection && howSection.querySelector('h2');
      if (howHeading) howHeading.setAttribute('tabindex', '-1');
      scrollToTarget(orderFlowAnchor || howSection, howHeading || howSection);
    }

    function lockBackground() {
      lockedScrollY = window.scrollY;
      savedBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        width: document.body.style.width,
        overflow: document.body.style.overflow,
        paddingRight: document.body.style.paddingRight
      };
      savedHtmlStyles = {
        overflow: document.documentElement.style.overflow
      };
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    }

    function restoreBackground() {
      if (savedHtmlStyles) document.documentElement.style.overflow = savedHtmlStyles.overflow;
      if (savedBodyStyles) {
        document.body.style.position = savedBodyStyles.position;
        document.body.style.top = savedBodyStyles.top;
        document.body.style.left = savedBodyStyles.left;
        document.body.style.width = savedBodyStyles.width;
        document.body.style.overflow = savedBodyStyles.overflow;
        document.body.style.paddingRight = savedBodyStyles.paddingRight;
      }
      window.scrollTo(0, lockedScrollY);
      window.requestAnimationFrame(function () { window.scrollTo(0, lockedScrollY); });
      savedHtmlStyles = null;
      savedBodyStyles = null;
    }

    function openMountDialog(trigger) {
      var activeTrigger = trigger || mountOpen;
      if (!mountDialog || mountDialog.open || !activeTrigger) return;
      var triggerRect = activeTrigger.getBoundingClientRect();
      var minTop = window.innerHeight * 0.22;
      var maxTop = window.innerHeight * 0.44;
      var desiredTop = triggerRect.top - 18;
      var safeTop = Math.min(Math.max(desiredTop, minTop), maxTop);
      clearTimeout(closeTimer);
      dialogReturnFocus = activeTrigger;
      lockBackground();
      mountDialog.style.setProperty('--ag-cf-mount-dialog-top', Math.round(safeTop) + 'px');
      mountDialog.showModal();
      window.scrollTo(0, lockedScrollY);
      mountDialog.setAttribute('aria-hidden', 'false');
      activeTrigger.setAttribute('aria-expanded', 'true');
      updatePurchaseState();
      window.requestAnimationFrame(function () {
        window.scrollTo(0, lockedScrollY);
        mountDialog.classList.add('is-visible');
        if (mountClose) mountClose.focus({ preventScroll: true });
      });
    }

    function closeMountDialog() {
      if (!mountDialog || !mountDialog.open) return;
      mountDialog.classList.remove('is-visible');
      closeTimer = window.setTimeout(function () {
        if (mountDialog.open) mountDialog.close();
      }, 180);
    }

    function handleDialogClose() {
      var navigateAfterDecision = decisionClosePending;
      decisionClosePending = false;
      if (dialogReturnFocus) dialogReturnFocus.setAttribute('aria-expanded', 'false');
      mountDialog.setAttribute('aria-hidden', 'true');
      restoreBackground();
      if (navigateAfterDecision) window.requestAnimationFrame(function () { scrollToArtworkOptions(mountOpen); });
      else if (dialogReturnFocus) dialogReturnFocus.focus({ preventScroll: true });
      dialogReturnFocus = mountOpen;
    }

    function submitForm(form, event) {
      event.preventDefault();
      var submit = form.querySelector('[data-cf-submit]');
      var errorBox = form.querySelector('[data-cf-error]');
      if (!submit || submit.getAttribute('aria-disabled') === 'true') return;

      updatePurchaseState();
      var cart = getCartController();
      var mountGroup = mountQuantity > 0 ? makeMountGroup() : '';
      var items = [formToItem(form, mountGroup)];
      if (mountQuantity > 0 && mountVariantId > 0) {
        items.push({
          id: mountVariantId,
          quantity: mountQuantity,
          properties: {
            _ag_mount_group: mountGroup,
            _ag_mount_role: 'display_add_on'
          }
        });
      }

      submit.setAttribute('aria-disabled', 'true');
      submit.disabled = true;
      form.classList.add('is-loading');
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      var payload = {
        items: items,
        sections: getSectionIds(cart),
        sections_url: window.location.pathname
      };

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart request failed');
            return data;
          });
        })
        .then(function (response) {
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          renderCartContents(cart, response);
        })
        .catch(function (error) {
          if (errorBox) {
            errorBox.hidden = false;
            errorBox.textContent = error.message;
          } else {
            console.error(error);
          }
        })
        .finally(function () {
          submit.disabled = false;
          submit.setAttribute('aria-disabled', 'false');
          form.classList.remove('is-loading');
        });
    }

    if (quantitySelect) quantitySelect.addEventListener('change', function () {
      setArtworkQuantity(quantitySelect.value);
    });

    if (quantityContinue) quantityContinue.addEventListener('click', scrollToArtworkOptions);

    if (finalForm) finalForm.addEventListener('submit', function (event) { submitForm(finalForm, event); });

    if (mountOpen) mountOpen.addEventListener('click', function () { openMountDialog(mountOpen); });
    if (summaryArtworkEdit) summaryArtworkEdit.addEventListener('click', function () { scrollToArtworkQuantity(quantitySelect); });
    if (summaryMountEdit) summaryMountEdit.addEventListener('click', function () { openMountDialog(summaryMountEdit); });
    if (mountClose) mountClose.addEventListener('click', closeMountDialog);
    if (mountDone) mountDone.addEventListener('click', function () {
      decisionClosePending = true;
      closeMountDialog();
    });
    if (detailBridge) detailBridge.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToDetailBridgeTarget();
    });
    if (mountDialog) {
      mountDialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeMountDialog();
      });
      mountDialog.addEventListener('click', function (event) {
        if (event.target === mountDialog) closeMountDialog();
      });
      mountDialog.addEventListener('close', handleDialogClose);
    }
    if (mountMinus) mountMinus.addEventListener('click', function () {
      if (mountQuantity > 0) {
        mountQuantity -= 1;
        updatePurchaseState();
      }
    });
    if (mountPlus) mountPlus.addEventListener('click', function () {
      if (mountQuantity < getArtworkQuantity(activePlan)) {
        mountQuantity += 1;
        updatePurchaseState();
      }
    });
    if (mountQuick) mountQuick.addEventListener('click', function () {
      mountQuantity = getArtworkQuantity(activePlan);
      updatePurchaseState();
    });
    if (mountAlign) mountAlign.addEventListener('click', function () {
      mountQuantity = getArtworkQuantity(activePlan);
      updatePurchaseState();
    });

    if (quantitySelect && !quantitySelect.value) quantitySelect.value = String(seriesMinimum);
    if (seriesInput && !seriesInput.value) seriesInput.value = String(seriesMinimum);
    activePlan = getPlanForQuantity(Number(quantitySelect && quantitySelect.value) || seriesMinimum);
    updatePurchaseState();
  }

  function init() {
    document.querySelectorAll('[data-ag-cf-v3]').forEach(initPurchase);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
